import { Injectable, ElementRef, RendererFactory2 } from '@angular/core';
import { positionElements } from './ng-positioning';
import { fromEvent, merge, of, animationFrameScheduler, Subject } from 'rxjs';
export class PositioningService {
    constructor(rendererFactory) {
        this.update$$ = new Subject();
        this.events$ = merge(fromEvent(window, 'scroll'), fromEvent(window, 'resize'), of(0, animationFrameScheduler), this.update$$);
        this.positionElements = new Map();
        this.events$
            .subscribe(() => {
            this.positionElements
                .forEach((positionElement) => {
                positionElements(_getHtmlElement(positionElement.target), _getHtmlElement(positionElement.element), positionElement.attachment, positionElement.appendToBody, rendererFactory.createRenderer(null, null));
            });
        });
    }
    position(options) {
        this.addPositionElement(options);
        this.update$$.next();
    }
    addPositionElement(options) {
        this.positionElements.set(_getHtmlElement(options.element), options);
    }
    deletePositionElement(elRef) {
        this.positionElements.delete(_getHtmlElement(elRef));
    }
}
PositioningService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
PositioningService.ctorParameters = () => [
    { type: RendererFactory2, },
];
function _getHtmlElement(element) {
    // it means that we got a selector
    if (typeof element === 'string') {
        return document.querySelector(element);
    }
    if (element instanceof ElementRef) {
        return element.nativeElement;
    }
    return element;
}
//# sourceMappingURL=positioning.service.js.map